export class ValueFunctionMap {
  value: string;
  calcFunction;

  constructor(value, calcFunction) {
    this.value = value;
    if (calcFunction != null) {
      this.calcFunction = calcFunction;
    } else {
      this.calcFunction = function (value) {
        return value;
      };
    }
  }
}
